import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, fontSize, fontWeight, letterSpacing, lineHeight, textStyle, width, compose, } from 'styled-system';
import propTypes from '@styled-system/prop-types';
import { applyVariations, getPaletteColor, deprecatedColorValue, textStylesValues, typographyAttrs, } from '../utils';
const nowrap = (props) => props.nowrap
    ? {
        whiteSpace: 'nowrap',
    }
    : null;
const accessiblyHide = (props) => props.hidden
    ? {
        position: 'absolute',
        width: '1px',
        height: '1px',
        clip: 'rect(1px, 1px, 1px, 1px)',
    }
    : null;
const labelPropTypes = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, propTypes.space), propTypes.fontSize), propTypes.fontWeight), propTypes.lineHeight), propTypes.textStyle), propTypes.width), { color: deprecatedColorValue(), textStyle: PropTypes.oneOf(textStylesValues) });
const Label = styled.label.attrs((props) => (Object.assign(Object.assign({}, typographyAttrs(props)), props))) `
  display: block;
  width: 100%;
  margin: 0;
  color: ${getPaletteColor('base')};
  ${(props) => (props.bg ? `background-color: ${getPaletteColor(props.bg, 'base')(props)};` : '')}
  ${(props) => (props.onClick ? 'cursor: pointer;' : '')}

  ${applyVariations('Label')}

  ${nowrap}
  ${accessiblyHide}

  ${(props) => compose(fontSize, fontWeight, lineHeight, letterSpacing, space, textStyle, width)(props)}
`;
Label.propTypes = labelPropTypes;
Label.defaultProps = {
    color: 'text.light',
    textStyle: 'label',
};
Label.displayName = 'Label';
Label.isLabel = true;
export default Label;
//# sourceMappingURL=Label.js.map